//***********************************************************************
//タグ選択チェックボックス（チェックが入ってる or 入った場合はcss背景色追加
//***********************************************************************

$(".c-tag-select-content input[type=checkbox]:checked").parent().parent().css("background", "#BFE6FF");

//クリックイベント
$(".c-tag-select-content input").click(function ({ target }) {
    const t = target.type;
    const chk = $(this).prop('checked');

    //チェックが入ったか入ってないかで条件分岐
    if (t == 'checkbox') {
        if (chk == true) {
            $(this).parent().parent().css('background', '#BFE6FF');
        }
        else {
            $(this).parent().parent().css('background', '#fff');
        }
        return true;
    }
});


//********************************************************************
//ジャンル選択の「セレクトボックスエリア」OPENボタン表示制御
//********************************************************************

//サジェストタブにチェックがはいっていたら非表示
if ('input.js-tab-l[type="radio"]:checked') {
    $('.js-c-tag-select-open-btn').css('display', 'none');
    //ジャンル選択がクリックされたら
    $('input.js-tab-r[type="radio"]').click(() => {
        if ($('.js-descriptionList_prt .js-descriptionList_prt')) {
            $('.js-c-tag-select-open-btn').css('display', 'block');
        }
    });

    //×ボタン（閉じる）押下でボタン表示
    $('button.js-descriptionList_close').click(() => {
        if ($('.js-descriptionList_prt is-close')) {
            $('.js-c-tag-select-open-btn').css('display', 'block');
            console.log('close');
        }
    });

    //設定ボタン（開く）押下でボタン非表示
    $('.js-descriptionList_open.js-c-tag-select-open-btn').click(() => {
        if ($('.js-descriptionList_prt .is-closable')) {
            $('.js-c-tag-select-open-btn').css('display', 'none');
        }
    });

    //サジェスト選択がクリックされたら
    $('input.js-tab-l[type="radio"]').click(() => {
        $('.js-c-tag-select-open-btn').css('display', 'none');
    });
}


//********************************************************************
//ジャンル選択
//********************************************************************
$(() => {
    //配列（checkboxの値）初期化
    const tagNameBox = [];

    //初期状態でチェックされているタグ
    $('input[name="tagNameBox[]"]:checked').each(function () {

        //値を配列に格納
        tagNameBox.push($(this).val());

        $(`<a class="article_tab_tbl_tag article_tab_tbl_tag-del js-tag-del"><span>${$(this).val()}</span></a>`).appendTo('.p1');
        console.log("初期checked :", ($(this).val()));
    });

    //チェック時処理
    $('input[name="tagNameBox[]"]').change(() => {

        //チェックされた時点で初期値非表示
        $('.p1').css('display', 'none');

        //配列初期化
        const tagNameBox = [];

        // ループ処理
        $('input[name="tagNameBox[]"]:checked').each(function () {

            //値を配列に格納
            $(this).show();
            tagNameBox.push($(this).val());
            if ($('.c-tag-select-tag').is(':visible')) {
                $(".c-tag-select-tag span").css('display', '');
                $('.p1').css('display', 'none');
            }
        });


        // $((e) => {
        //   //ajax通信で全てのタグリスト（type:checkbox='value' , checkedの有無）等を取得し
        //   //HTML上に展開する（それをもとにcheckboxを作成）
        //   const tagListNumber = $('.c-tag-select-wrapper-outer input:checkbox').length;

        //   if($(".c-tag-select-wrapper-outer")) {
        //     const tagNameArrayBox = $('input[name="tagNameBox[]"]').map(function(){
        //       return $(this).val();
        //     }).get();
        //     //console.log("タグリスト配列 : " , tagNameArrayBox);

        //     for (let i=0; i < tagListNumber; i++) {
        //       //展開データ内容をチェックボックスエリア、選択済エリアに展開
        //     }
        //   }
        // });


        // TODO : 現状value値ベタで入れていますが、ループ化予定
        $('.p2').html(`<a class="article_tab_tbl_tag article_tab_tbl_tag-del js-tag-del"><span>${tagNameBox[0]}</span></a>`).on('click', function () {
            const p2 = "見える化・意思決定";
            if (p2 == "見える化・意思決定") {
                $(this).prop("checked", false);
                //一旦上のhide
                $(this).hide();
                $('input[value="見える化・意思決定"]').prop('checked', false).change().parent().parent().css('background', '#fff');
            }
            else {
                console.log("undifine");
                return false;
            }
        });

        $('.p3').html(`<a class="article_tab_tbl_tag article_tab_tbl_tag-del js-tag-del"><span>${tagNameBox[1]}</span></a>`).on('click', function () {
            const p3 = "業務効率化";
            if (p3 == "業務効率化") {
                $(this).prop("checked", false);
                $(this).hide();
                $('input[value="業務効率化"]').prop('checked', false).change().parent().parent().css('background', '#fff');
            }
            else {
                console.log("undifine");
                return false;
            }
        });

        $('.p4').html(`<a class="article_tab_tbl_tag article_tab_tbl_tag-del js-tag-del"><span>${tagNameBox[2]}</span></a>`).on('click', function () {
            const p3 = "ITコスト削減";
            if (p3 == "ITコスト削減") {
                $(this).prop("checked", false);
                $(this).hide();
                $('input[value="ITコスト削減"]').prop('checked', false).change().parent().parent().css('background', '#fff');
            }
            else {
                console.log("undifine");
                return false;
            }
        });

        $('.p5').html(`<a class="article_tab_tbl_tag article_tab_tbl_tag-del js-tag-del"><span>${tagNameBox[3]}</span></a>`).on('click', function () {
            const p5 = "テレワーク";
            if (p5 == "テレワーク") {
                $(this).prop("checked", false);
                $(this).hide();
                $('input[value="テレワーク"]').prop('checked', false).change().parent().parent().css('background', '#fff');
            }
            else {
                console.log("undifine");
                return false;
            }
        });

        $('.p6').html(`<a class="article_tab_tbl_tag article_tab_tbl_tag-del js-tag-del"><span>${tagNameBox[4]}</span></a>`).on('click', function () {
            const p6 = "OJT";
            if (p6 == "OJT") {
                $(this).prop("checked", false);
                $(this).hide();
                $('input[value="OJT"]').prop('checked', false).change().parent().parent().css('background', '#fff');
            }
            else {
                console.log("undifine");
                return false;
            }
        });

        $('.p7').html(`<a class="article_tab_tbl_tag article_tab_tbl_tag-del js-tag-del"><span>${tagNameBox[5]}</span></a>`).on('click', function () {
            const p7 = "Eラーニング";
            if (p7 == "Eラーニング") {
                $(this).prop("checked", false);
                $(this).hide();
                $('input[value="Eラーニング"]').prop('checked', false).change().parent().parent().css('background', '#fff');
            }
            else {
                console.log("undifine");
                return false;
            }
        });

        $('.p8').html(`<a class="article_tab_tbl_tag article_tab_tbl_tag-del js-tag-del"><span>${tagNameBox[6]}</span></a>`).on('click', function () {
            const p8 = "HRテック";
            if (p8 == "HRテック") {
                $(this).prop("checked", false);
                $(this).hide();
                $('input[value="HRテック"]').prop('checked', false).change().parent().parent().css('background', '#fff');
            }
            else {
                console.log("undifine");
                return false;
            }
        });

        $('.p9').html(`<a class="article_tab_tbl_tag article_tab_tbl_tag-del js-tag-del"><span>${tagNameBox[7]}</span></a>`).on('click', function () {
            const p9 = "キャリアパス";
            if (p9 == "キャリアパス") {
                $(this).prop("checked", false);
                $(this).hide();
                $('input[value="キャリアパス"]').prop('checked', false).change().parent().parent().css('background', '#fff');
            }
            else {
                console.log("undifine");
                return false;
            }
        });

        $('.p10').html(`<a class="article_tab_tbl_tag article_tab_tbl_tag-del js-tag-del"><span>${tagNameBox[8]}</span></a>`).on('click', function () {
            const p10 = "働き方";
            if (p10 == "働き方") {
                $(this).prop("checked", false);
                $(this).hide();
                $('input[value="働き方"]').prop('checked', false).change().parent().parent().css('background', '#fff');
            }
            else {
                console.log("undifine");
                return false;
            }
        });

        $('.p11').html(`<a class="article_tab_tbl_tag article_tab_tbl_tag-del js-tag-del"><span>${tagNameBox[9]}</span></a>`).on('click', function () {
            const p11 = "パラレルキャリア";
            if (p11 == "パラレルキャリア") {
                $(this).prop("checked", false);
                $(this).hide();
                $('input[value="パラレルキャリア"]').prop('checked', false).change().parent().parent().css('background', '#fff');
            }
            else {
                console.log("undifine");
                return false;
            }
        });

        $('.p12').html(`<a class="article_tab_tbl_tag article_tab_tbl_tag-del js-tag-del"><span>${tagNameBox[10]}</span></a>`).on('click', function () {
            const p12 = "ブラザー・シスター制度";
            if (p12 == "ブラザー・シスター制度") {
                $(this).prop("checked", false);
                $(this).hide();
                $('input[value="ブラザー・シスター制度"]').prop('checked', false).change().parent().parent().css('background', '#fff');
            }
            else {
                console.log("undifine");
                return false;
            }
        });
        //undefined（チェックが外れたcheckbox）非表示処理
        $("span:contains('undefined')").hide();
    });
});